// src/services/api.js
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || (process.env.REACT_APP_API_URL || process.env.REACT_APP_API_URL);

const api = axios.create({
  baseURL: API_URL,
});

// Token automatisch zu jedem Request hinzufÃ¼gen
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Auth API
export const authAPI = {
  login: (email, password) => api.post('/auth/login', { email, password }),
  register: (email, password, name) => api.post('/auth/register', { email, password, name }),
  verify: () => api.get('/auth/verify'),
};

// Organization API - NEU!
export const organizationAPI = {
  getCurrent: () => api.get('/organizations/current'),
  getStats: () => api.get('/organizations/stats'),
  update: (data) => api.put('/organizations/current', data),
  uploadLogo: (file) => {
    const formData = new FormData();
    formData.append('logo', file);
    return api.post('/organizations/logo', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  },
};

// Screens API
export const screensAPI = {
  getAll: () => api.get('/screens'),
  create: (data) => api.post('/screens', data),
  update: (id, data) => api.put(`/screens/${id}`, data),
  delete: (id) => api.delete(`/screens/${id}`),
  assignPlaylist: (id, playlistId) => api.put(`/screens/${id}/playlist`, { playlist_id: playlistId }),
};

// Media API
export const mediaAPI = {
  getAll: () => api.get('/media'),
  create: (data) => api.post('/media', data),
  upload: (formData) => api.post('/media/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),
  delete: (id) => api.delete(`/media/${id}`),
};

// Playlists API
export const playlistsAPI = {
  getAll: () => api.get('/playlists'),
  getOne: (id) => api.get(`/playlists/${id}`),
  create: (data) => api.post('/playlists', data),
  update: (id, data) => api.put(`/playlists/${id}`, data),
  updateItems: (id, mediaIds) => api.put(`/playlists/${id}/items`, { media_ids: mediaIds }),
  delete: (id) => api.delete(`/playlists/${id}`),
};

// Groups API
export const groupsAPI = {
  getAll: () => api.get('/groups'),
  create: (data) => api.post('/groups', data),
  update: (id, data) => api.put(`/groups/${id}`, data),
  delete: (id) => api.delete(`/groups/${id}`),
  reorder: (groupOrders) => api.put('/groups/reorder', { groupOrders }),
  assignScreen: (screenId, groupId) => api.put(`/groups/assign/${screenId}`, { group_id: groupId }),
};

// Users API
export const usersAPI = {
  getAll: () => api.get('/users'),
  create: (data) => api.post('/users', data),
  updateRole: (id, role) => api.put(`/users/${id}/role`, { role }),
  delete: (id) => api.delete(`/users/${id}`),
  resetPassword: (id, password) => api.post(`/users/${id}/reset-password`, { password }),
};

// Stats API
export const statsAPI = {
  getScreens: () => api.get('/stats/screens'),
  getScreenHealth: (id) => api.get(`/stats/screens/${id}/health`),
  getOverview: () => api.get('/stats/overview'),
};

// Schedules API
export const schedulesAPI = {
  getAll: () => api.get('/schedules'),
  create: (data) => api.post('/schedules', data),
  delete: (id) => api.delete(`/schedules/${id}`),
  getActive: (screenId) => api.get(`/schedules/active/${screenId}`),
};

export default api;

